__turbopack_context__.v({
  "banner": "VideoBgBase-module-scss-module__FnHbUW__banner",
  "bgGradient": "VideoBgBase-module-scss-module__FnHbUW__bgGradient",
  "btnWrapper": "VideoBgBase-module-scss-module__FnHbUW__btnWrapper",
  "container": "VideoBgBase-module-scss-module__FnHbUW__container",
  "containerImgBgMode": "VideoBgBase-module-scss-module__FnHbUW__containerImgBgMode",
  "containerReversed": "VideoBgBase-module-scss-module__FnHbUW__containerReversed",
  "isFirst": "VideoBgBase-module-scss-module__FnHbUW__isFirst",
  "isParallax": "VideoBgBase-module-scss-module__FnHbUW__isParallax",
  "section": "VideoBgBase-module-scss-module__FnHbUW__section",
  "text": "VideoBgBase-module-scss-module__FnHbUW__text",
  "textBlock": "VideoBgBase-module-scss-module__FnHbUW__textBlock",
  "title": "VideoBgBase-module-scss-module__FnHbUW__title",
  "video": "VideoBgBase-module-scss-module__FnHbUW__video",
});
